import { API } from "@project/shared"

export const fetchCompany = async () => {
  return API.get(`/child-parent/company_informations`)
}
